import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0f58aa2f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "study-compare" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "version-block" }
const _hoisted_4 = { class: "version-header" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Study Version ")
const _hoisted_6 = ["value"]
const _hoisted_7 = ["open"]
const _hoisted_8 = { class: "visit" }
const _hoisted_9 = { class: "version-block" }
const _hoisted_10 = { class: "version-header" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Study Version ")
const _hoisted_12 = ["value"]
const _hoisted_13 = ["open"]
const _hoisted_14 = { class: "visit" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "diff-legend" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "legend-added" }, "Added"),
  /*#__PURE__*/_createElementVNode("span", { class: "legend-removed" }, "Deleted"),
  /*#__PURE__*/_createElementVNode("span", { class: "legend-modified" }, "Modified")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ActivityItem = _resolveComponent("ActivityItem")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _withDirectives(_createElementVNode("select", {
            class: "form-select form-select-sm d-inline-block w-auto",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedVersionOld) = $event)),
            onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.validateandloadGraph('old')))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.versionList, (ver) => {
              return (_openBlock(), _createElementBlock("option", {
                key: ver,
                value: ver
              }, _toDisplayString(ver), 9, _hoisted_6))
            }), 128))
          ], 544), [
            [_vModelSelect, _ctx.selectedVersionOld]
          ])
        ]),
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.left.visits, (visit, i) => {
            return (_openBlock(), _createElementBlock("li", {
              key: visit.visitName || i,
              class: _normalizeClass(_ctx.statusClass(visit.status)),
              style: _normalizeStyle(_ctx.inlineColorStyle(visit.color))
            }, [
              _createElementVNode("details", {
                open: i === 0
              }, [
                _createElementVNode("summary", null, "Visit : " + _toDisplayString(visit.visitName), 1),
                _createElementVNode("ul", _hoisted_8, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visit.activities, (root, ri) => {
                    return (_openBlock(), _createBlock(_component_ActivityItem, {
                      key: (root.activityName||'')+ri,
                      node: root,
                      idx: ri
                    }, null, 8, ["node", "idx"]))
                  }), 128))
                ])
              ], 8, _hoisted_7)
            ], 6))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _withDirectives(_createElementVNode("select", {
            class: "form-select form-select-sm d-inline-block w-auto",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedVersionNew) = $event)),
            onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.validateandloadGraph('new')))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.versionList, (ver) => {
              return (_openBlock(), _createElementBlock("option", {
                key: ver,
                value: ver
              }, _toDisplayString(ver), 9, _hoisted_12))
            }), 128))
          ], 544), [
            [_vModelSelect, _ctx.selectedVersionNew]
          ])
        ]),
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.right.visits, (visit, i) => {
            return (_openBlock(), _createElementBlock("li", {
              key: visit.visitName || i,
              class: _normalizeClass(_ctx.statusClass(visit.status)),
              style: _normalizeStyle(_ctx.inlineColorStyle(visit.color))
            }, [
              _createElementVNode("details", {
                open: i === 0
              }, [
                _createElementVNode("summary", null, "Visit : " + _toDisplayString(visit.visitName), 1),
                _createElementVNode("ul", _hoisted_14, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visit.activities, (root, ri) => {
                    return (_openBlock(), _createBlock(_component_ActivityItem, {
                      key: (root.activityName||'')+ri,
                      node: root,
                      idx: ri
                    }, null, 8, ["node", "idx"]))
                  }), 128))
                ])
              ], 8, _hoisted_13)
            ], 6))
          }), 128))
        ])
      ])
    ]),
    _hoisted_15
  ]))
}